module.exports = __webpack_public_path__ + "static/media/story_04.9f178c56.jpg";